import { UseFormPayload } from '@domain-group/react-hooks'

import { Box, Line, Text } from '@domain-group/suit-theme'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import useSelector from '@hooks/useSelector'

import ToggleListItem from '@components/ToggleListItem'

interface Permission {
  key: string,
  is_enabled: boolean,
  title: string,
}

interface PermissionListProps {
  permissionData: Record<string, Permission[]>,
  profileType: string,
  selectedRoleId: number,
  setState: UseFormPayload['setEntityState'],
}

const PermissionList = (props: PermissionListProps) => {
  const {
    permissionData,
    profileType,
    selectedRoleId,
    setState,
  } = props

  const roles = useSelector(reduxState => reduxState.entities.roles)
  const role = roles[selectedRoleId] || {}

  return (
    <>
      <Text color="bodyFontLightColor" fontSize="small">
        Set default user permissions for {snakeToTitleCase(profileType)}
      </Text>

      <Line />

      <Box flexDirection="column">
        {Object.entries(permissionData).map(([group, permissions], groupIdx, arr) => (
          <Box
            key={group}
            borderBottom={groupIdx === arr.length - 1 ? 'none' : '1px dashed'}
            borderColor="lineColor"
            flexDirection="column"
            paddingY="medium"
          >
            <Text color="bodyFontLightColor" marginY="medium" fontSize="xsmall">
              {snakeToTitleCase(group)}
            </Text>

            {(permissions).map((permission) => {
              const { key, is_enabled: isEnabled } = permission

              if (role?.key === 'office_administrator' && permission.key === 'order_item_dispatched_email') return null

              return (
                <ToggleListItem
                  key={key}
                  boxProps={{ marginBottom: 'medium' }}
                  onClick={() => {
                    setState(
                      {
                        permissionData: {
                          ...permissionData,
                          [group]: (permissions).map(p => (p.key === key ? { ...p, is_enabled: !isEnabled } : p)),
                        },
                      },
                    )
                  }}
                  toggleValue={isEnabled}
                >
                  <Text fontSize="small" maxWidth="fit-content" variant="twoLineEllipsis" paddingRight="large">
                    {snakeToTitleCase(key)}
                  </Text>
                </ToggleListItem>
              )
            })}
          </Box>
        ))}
      </Box>
    </>
  )
}

export default PermissionList
